/** Install a cryptographically secure UUID fallback where the native API is absent. */
export function installRandomUUID(cryptoApi: Crypto | undefined): void {
  if (
    !cryptoApi ||
    typeof cryptoApi.randomUUID === 'function' ||
    typeof cryptoApi.getRandomValues !== 'function'
  ) {
    return;
  }

  // HTTP LAN origins expose getRandomValues, but not randomUUID. Libraries
  // such as workspace presence call randomUUID during their first render.
  cryptoApi.randomUUID = () => {
    const bytes = cryptoApi.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6]! & 0x0f) | 0x40;
    bytes[8] = (bytes[8]! & 0x3f) | 0x80;
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
  };
}
